import styled from '@emotion/styled';
import * as main from '../../../styles/abstracts/vars.module.scss';

export const SWrapper = styled.div<{ $error: boolean; $required?: boolean; $autosize?: boolean }>`
  ${(p) => p.$autosize && `width:100%`};

  textarea {
    width: 100%;
    height: 100%;
    padding: 10px;
    resize: none;
    border: 1px solid ${(p) => (p.$error ? main.colorError : main.colorBorder)};
    border-radius: 6px;
    outline: none;
    font-size: ${main.fontMedium};
    font-family: Roboto;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    ::placeholder {
      color: transparent;
    }

    &:not(:read-only):hover:enabled,
    &:not(:read-only):focus {
      border-color: ${main.colorActive};
    }

    &:read-only {
      border-color: ${main.colorBgPrimary};
      background-color: ${main.colorBgPrimary};
      color: ${main.colorTextSecondary};
    }
      
    &:focus {
      .placeholder {
        color: transparent;
      }
    }
      
  }

  .placeholder {
    position: absolute;

    top: 10px;
    padding-left: 10px;

    pointer-events: none;

    color: ${main.colorTextSecondary};

    ${(p) =>
      p.$required &&
      `&::after {
								content: '*';
								color: ${main.colorError};
							}`}
  }

  textarea:not(:placeholder-shown) + .placeholder {
    display: none;
  }

  position: relative;
`;
